export enum IdbFallbackReason {
    /**
     * Fall back because this resolver, or this resolver on this data,
     * is not supported by Idb.
     */
    NotSupportedByIdb,
}
